import React, { useEffect, useState } from 'react';
import { animate, useReducedMotion } from 'framer-motion';
import type { KpiFormat } from '../../data/insights';
type CountUpProps = {
  value: number;
  format?: KpiFormat;
  className?: string;
};

/** A short, settle-in count so figures feel measured rather than static. */
export function CountUp({
  value,
  format = 'int',
  className = ''
}: CountUpProps) {
  const reduced = useReducedMotion();
  const [n, setN] = useState(reduced ? value : 0);
  useEffect(() => {
    if (reduced) {
      setN(value);
      return;
    }
    const controls = animate(0, value, {
      duration: 0.7,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: v => setN(v)
    });
    return () => controls.stop();
  }, [value, reduced]);
  return <span className={`tabular ${className}`} aria-label={fmt(value, format)} data-id="element-67" data-mp="3u99q8uybz7an">
      {fmt(n, format)}
    </span>;
}
function fmt(v: number, format: KpiFormat) {
  const r = Math.round(v);
  if (format === 'time') return `${Math.floor(r / 60)}:${String(r % 60).padStart(2, '0')}`;
  return r.toLocaleString('en-GB');
}